import { render, staticRenderFns } from "./payment-methods.vue?vue&type=template&id=fc552cc0&scoped=true&"
import script from "./payment-methods.vue?vue&type=script&lang=js&"
export * from "./payment-methods.vue?vue&type=script&lang=js&"
import style0 from "./payment-methods.vue?vue&type=style&index=0&id=fc552cc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc552cc0",
  null
  
)

/* custom blocks */
import block0 from "./payment-methods.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports